import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import moment from 'moment';
import { QuestionType } from '../models/enums/QuestionType';

let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const T = Translator.create();
const _logger = Log.create('Question-Service');

export class QuestionService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetQuestionListsAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/question/list', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }
    public async RequestAddQuestionAsync(params: any) {
        let url = 'api/question/insert';
        if (params && params.questionId) {
            url = 'api/question/update';
        }

        return _apiClient.RequestAsync('POST', url, params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }
    public async RequestDeleteAddQuestionAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/question/delete', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }
    public async RequestGetQuestionsAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/question/show', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }
    public async RequestGetQuestionEditAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/question/edit',params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetQuestionByIdAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/question/getbyid',params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetQuestionDifficultiesAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/question/getDifficulties',params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetQuestionPreviewAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/question/PreviewQuestion', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RedirectToAlmsQuestionBank(params?: any) {
        const parsedUrl = new URL(window.location.href);

        return _apiClient.RequestAsync('POST', 'api/account/ConnectWebToAlms', {
            host: parsedUrl.hostname,
            port: parsedUrl.port,
            scheme: parsedUrl.protocol,
            isReturnUrl: true,
            returnType: 'question',
            courseId: params && params.courseId ? params.courseId : '',
            classId: params && params.classId ? params.classId : '',
            activityId: params && params.activityId ? params.activityId : '',
            enrollmentId: params && params.enrollmentId ? params.enrollmentId : ''
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestDownloadTemplateExcelAsync(timestamp: Date, questionType: QuestionType) {

        const dateStr = moment(timestamp).format("YYMMMDD-HHmm");
        try {
            const responseData = await _apiClient.RequestAsync('GET', 'api/question/downloadtemplateexcel', undefined, token);
    
            const blob = await responseData.blob();
            const objectURL = URL.createObjectURL(blob);
            
            let questionTypeName =  QuestionType[questionType];
            
            const link = document.createElement('a');
            link.href = objectURL;
            link.setAttribute('download', `ALMS-QuestionImportTemplate-${questionTypeName}-${dateStr}.xlsx`);
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
            URL.revokeObjectURL(objectURL);
    
            return null; 
        } catch (error) {
            return error; 
        }
    }

    public async RequestGetRefreshUploadMultiQuestionAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/question/refreshuploadmultiquestion', params, token)
        .then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }
}